<template>
  <div>
    <div class="modal">
      <Spinner v-if="isLoadingData" :fullscreen="true">
        <template v-slot:header
          >Fetch prefix list of your ASN</template
        >
        We are loading your data.
        <br />This may take a few seconds.</Spinner
      >
      <!-- for non-mobile -->
      <div v-if="!isMobile" class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="showConfirmModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="modal-body__left">
              <Steps
                :index="innerPageIndex"
                :isVisitedObj="isInnerPageVisitedObj"
                :isApplyBtnDisabled="isApplyBtnDisabled"
                :isSubmitBtnDisabled="isSubmitBtnDisabled"
                @changeStep="changeStep"
              ></Steps>
            </div>
            <div class="modal-body__right">
              <Trigger
                v-if="innerPageIndex === 1"
                :prefixList="prefixListOfSelectedASN"
                :prevSelectedPrefixList="selectedPrefixList"
                :prevTriggerType="triggerType"
                @updateSelectedPrefixList="updateSelectedPrefixList"
                @onTriggerTypeChange="setTriggerTypeChange"
              ></Trigger>
              <Rule
                v-if="innerPageIndex === 2"
                :prevAlertRule="alertRule"
              ></Rule>
              <Action
                v-if="innerPageIndex === 3"
                :prevEmail="email"
                @updateEmail="updateEmail"
              ></Action>
              <AlertName
                v-if="innerPageIndex === 4"
                :alertName="alertName"
                @confirmInput="confirmAlertName"
              ></AlertName>
            </div>
          </div>
          <div v-if="!isEditing" class="modal-footer">
            <button
              v-if="innerPageIndex > 1"
              type="button"
              class="btn btn-outline-primary"
              :class="{
                disabled:
                  isApplyBtnDisabled ||
                  (innerPageIndex === 4 && isSubmitBtnDisabled)
              }"
              @click="innerPageIndex--"
            >
              Previous
            </button>
            <button
              v-if="innerPageIndex < 4"
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled }"
              @click="applyCurrentStepSetting"
            >
              Next
            </button>
            <button
              v-if="innerPageIndex === 4"
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled || isSubmitBtnDisabled }"
              @click="submit"
            >
              Submit
            </button>
          </div>
          <div v-else class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-primary"
              @click="showConfirmModal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled || isSubmitBtnDisabled }"
              @click="submit"
            >
              Save
            </button>
          </div>
        </div>
      </div>

      <!-- for mobile -->
      <div v-if="isMobile" id="mobile" class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeConfirmModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div
              v-if="innerPageIndex === 0 || isEditing"
              :class="{ 'nav-page': !isEditing, 'nav-tab': isEditing }"
            >
              <Steps
                :index="innerPageIndex"
                :isVisitedObj="isInnerPageVisitedObj"
                :isApplyBtnDisabled="isApplyBtnDisabled"
                :isSubmitBtnDisabled="isSubmitBtnDisabled"
                @changeStep="changeStep"
              ></Steps>
            </div>
            <Trigger
              v-if="innerPageIndex === 1"
              :prefixList="prefixListOfSelectedASN"
              :prevSelectedPrefixList="selectedPrefixList"
              :prevTriggerType="triggerType"
              @updateSelectedPrefixList="updateSelectedPrefixList"
              @backToIndexPage="backToIndexPage"
              @onTriggerTypeChange="setTriggerTypeChange"
            ></Trigger>
            <Rule
              v-if="innerPageIndex === 2"
              :prevAlertRule="alertRule"
              @backToIndexPage="backToIndexPage"
            >
            </Rule>
            <Action
              v-if="innerPageIndex === 3"
              :prevEmail="email"
              @updateEmail="updateEmail"
              @backToIndexPage="backToIndexPage"
            ></Action>
            <AlertName
              v-if="innerPageIndex === 4"
              :alertName="alertName"
              @confirmInput="confirmAlertName"
              @backToIndexPage="backToIndexPage"
            ></AlertName>
          </div>
          <div v-if="!isEditing && innerPageIndex !== 0" class="modal-footer">
            <button
              v-if="innerPageIndex > 0"
              type="button"
              class="btn btn-outline-primary"
              :class="{
                disabled:
                  isApplyBtnDisabled ||
                  (innerPageIndex === 4 && isSubmitBtnDisabled)
              }"
              @click="innerPageIndex--"
            >
              Previous
            </button>
            <button
              v-if="innerPageIndex < 4"
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled }"
              @click="applyCurrentStepSetting"
            >
              Next
            </button>
            <button
              v-if="innerPageIndex === 4"
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled || isSubmitBtnDisabled }"
              @click="submit"
            >
              Submit
            </button>
          </div>
          <div v-else-if="isEditing" class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-primary"
              @click="showConfirmModal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled || isSubmitBtnDisabled }"
              @click="submit"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--Confirm close modal -->
    <div v-if="isShowConfirmModal" class="modal confirm-close">
      <div class="modal-dialog" v-click-outside="continueEditing">
        <div class="modal-content">
          <div class="modal-header">
            Discard alert?
          </div>
          <div class="modal-body">The changes you made will be lost.</div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-danger"
              @click="closeAlertModal"
            >
              Yes, close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="continueEditing"
            >
              Continue editing
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import * as vClickOutside from 'v-click-outside';

import Steps from './Steps.vue';
import Trigger from './Trigger.vue';
import Rule from './Rule.vue';
import Action from './Action.vue';
import AlertName from './AlertName.vue';
// Remove it temporarily as we will implement email change later
// import { checkIsValidEmail } from '../../../utils/common';
import mixin from '../../../utils/mixin';
import Spinner from '../../ui/Spinner.vue';
import { checkIsInteger } from '../../../utils/common';
import { TRIGGER_TYPE } from '../../../constants/alertsConstant';

export default {
  name: 'CreateAlertRuleModal',
  components: { Steps, Trigger, Rule, Action, AlertName, Spinner },
  mixins: [mixin],
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    isEditing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerPageIndex: 0,
      isInnerPageVisitedObj: {
        1: true,
        2: false,
        3: false,
        4: false
      },
      selectedPrefixList: [],
      alertRule: {
        isTriggeredByFirstHit: true,
        isTriggeredByHitNumber: true,
        hitNumberPerDay: 1
      },
      email: '',
      alertName: '',
      isShowConfirmModal: false,
      isValidAlertName: this.isEditing ? true : false,
      isPageIndexChanged: false,
      initialData: {},
      triggerType: TRIGGER_TYPE.PREFIX_ANNOUNCED_BY_ASN
    };
  },
  computed: {
    ...mapGetters('authStore', ['oidcUser']),
    ...mapGetters('dataStore', ['selectedASN', 'selectedAccount']),
    ...mapGetters('alertsSuspiciousTrafficStore', ['prefixListOfSelectedASN']),
    ...mapState('alertsSuspiciousTrafficStore', [
      'isLoadingData',
      'editingAlertObj'
    ]),
    isApplyBtnDisabled() {
      const isSelectedPrefixListEmpty =
        this.triggerType === TRIGGER_TYPE.PREFIX_SELECTED_INDIVIDUALLY &&
        this.selectedPrefixList.length === 0;
      const isAlertRuleEmpty =
        !this.alertRule.isTriggeredByFirstHit &&
        !this.alertRule.isTriggeredByHitNumber;
      const isValidHitNumber =
        this.alertRule.hitNumberPerDay > 0 &&
        this.alertRule.hitNumberPerDay < 1000001 &&
        checkIsInteger(this.alertRule.hitNumberPerDay);

      // Remove it temporarily as we will implement email change later
      // const isValidEmail = checkIsValidEmail(this.email);

      return isSelectedPrefixListEmpty || isAlertRuleEmpty || !isValidHitNumber;
    },
    isSubmitBtnDisabled() {
      return !this.isValidAlertName;
    },
    title() {
      return this.isEditing ? 'Edit alert' : 'Create alert';
    }
  },
  methods: {
    ...mapActions('alertsSuspiciousTrafficStore', ['fetchPrefixesByASN']),
    showConfirmModal() {
      const isDataChanged = this.checkIsDataChanged();

      if (isDataChanged) {
        this.isShowConfirmModal = true;
      } else {
        this.closeAlertModal();
      }
    },
    closeAlertModal() {
      this.isShowConfirmModal = false;
      this.$emit('closeModal');
    },
    continueEditing() {
      this.isShowConfirmModal = false;
    },
    submit() {
      let triggerMember = null;
      let triggerAsn = null;
      let triggerPrefixes = null;

      if (this.triggerType === TRIGGER_TYPE.PREFIX_ANNOUNCED_BY_ASN) {
        triggerAsn = Number(this.selectedASN.id);
      } else if (
        this.triggerType === TRIGGER_TYPE.PREFIX_DELEGATED_TO_ACCOUNT
      ) {
        triggerMember = Number(this.selectedAccount.id);
      } else if (
        this.triggerType === TRIGGER_TYPE.PREFIX_SELECTED_INDIVIDUALLY
      ) {
        triggerPrefixes = [...this.selectedPrefixList];
      }

      const alert = {
        asn: parseInt(this.selectedASN.id),
        alertName: this.alertName,
        alertRule: { ...this.alertRule },
        email: this.email,
        triggerPrefixes,
        triggerAsn,
        triggerMember
      };

      this.$emit('submitAlert', alert);
    },
    changeStep(stepId) {
      !this.isPageIndexChanged && (this.isPageIndexChanged = true);

      this.innerPageIndex = stepId;
    },
    applyCurrentStepSetting() {
      this.innerPageIndex++;
      this.isInnerPageVisitedObj[this.innerPageIndex] = true;
    },
    updateSelectedPrefixList(val) {
      this.selectedPrefixList = val;
    },
    setTriggerTypeChange(val) {
      this.triggerType = val;
    },
    updateEmail(val) {
      this.email = val;
    },
    backToIndexPage() {
      this.innerPageIndex = 0;
    },
    confirmAlertName({ alertName, isValidAlertName }) {
      this.alertName = alertName;
      this.isValidAlertName = isValidAlertName;
    },
    closeConfirmModal() {
      if (
        this.isMobile &&
        !this.isEditing &&
        this.innerPageIndex === 0 &&
        !this.isPageIndexChanged
      ) {
        // Close Alert modal directly when create modal on mobile devices and users have stayed on category page
        this.closeAlertModal();
      } else {
        this.showConfirmModal();
      }
    },
    checkIsDataChanged() {
      const isSelectedPrefixListChanged =
        JSON.stringify(this.initialData.selectedPrefixList) !==
        JSON.stringify(this.selectedPrefixList);
      const isAlertRuleChanged =
        JSON.stringify(this.initialData.alertRule) !==
        JSON.stringify(this.alertRule);
      const isEmailChanged = this.initialData.email !== this.email;
      const isAlertNameChanged = this.initialData.alertName !== this.alertName;

      return (
        isSelectedPrefixListChanged ||
        isAlertRuleChanged ||
        isEmailChanged ||
        isAlertNameChanged
      );
    }
  },
  mounted() {
    // Close modal with 'esc' key
    document.addEventListener('keydown', e => {
      if (e.code == 'Escape') {
        if (this.isShowConfirmModal) {
          this.continueEditing();
        } else {
          this.showConfirmModal();
        }
      }
    });

    this.innerPageIndex = this.isMobile && !this.isEditing ? 0 : 1;

    // If in edit mode, preset Alert config
    if (this.isEditing) {
      if (this.editingAlertObj.triggerAsn) {
        this.triggerType = TRIGGER_TYPE.PREFIX_ANNOUNCED_BY_ASN;
      } else if (this.editingAlertObj.triggerMember) {
        this.triggerType = TRIGGER_TYPE.PREFIX_DELEGATED_TO_ACCOUNT;
      } else if (this.editingAlertObj.triggerPrefixes) {
        this.triggerType = TRIGGER_TYPE.PREFIX_SELECTED_INDIVIDUALLY;
        this.selectedPrefixList = JSON.parse(
          JSON.stringify(this.editingAlertObj.triggerPrefixes)
        );
      }

      this.alertRule.isTriggeredByFirstHit =
        this.editingAlertObj.triggerOnFirstHit || false;
      this.alertRule.isTriggeredByHitNumber =
        !!this.editingAlertObj.triggerOnNumHits || false;
      this.alertRule.hitNumberPerDay =
        this.editingAlertObj.triggerOnNumHits || 1;

      this.alertName = this.editingAlertObj.name;
      this.email = this.editingAlertObj.emailContact;
    } else {
      this.email = this.oidcUser.email || '';
    }

    this.initialData = {
      selectedPrefixList: [...this.selectedPrefixList],
      alertRule: { ...this.alertRule },
      email: this.email,
      alertName: this.alertName
    };
  }
};
</script>

<style lang="scss" scoped>
.modal {
  z-index: 1030;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.6);
}

.modal-dialog {
  max-width: initial;
  width: 80%;
}

.modal-header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  h5 {
    height: 2.375rem;
    line-height: 2.375rem;
  }

  .close {
    font-size: 2rem;
  }

  &__left {
    flex: 1;
  }

  &__right {
    flex: 2;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;

    & > span {
      font-weight: 600;
    }
  }
}

.modal-body {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 0;
  height: 70vh;

  &.disabled-mask::before {
    @include disabled-mask;
  }

  &__left {
    flex: 1;
  }

  &__right {
    flex: 2;
  }
}

.modal-footer {
  position: relative;

  &.disabled-mask::before {
    @include disabled-mask;
  }

  .disabled {
    pointer-events: none;
    cursor: not-allowed;
  }
}

#mobile {
  &.modal-dialog {
    width: 100vw;
    height: 100%;
    margin: 0;
  }

  .modal-content {
    height: 100%;
  }

  .modal-header {
    height: 3rem;
    line-height: 3rem;
    background-color: $text-light-blue;

    h5 {
      line-height: 1;
      color: #fff;
    }

    button {
      margin: -1.5rem -0.5rem 0 0;
      padding: 1rem;
      color: #fff;
      opacity: 1;
      font-size: 2rem;
    }
  }

  .modal-body {
    flex-direction: column;

    &.disabled-mask::before {
      @include disabled-mask;
      top: 5rem;
    }

    .nav-page {
      height: 100%;
      padding-top: 1.5rem;
      background-color: $background-grey;

      & > span {
        padding: 0 1rem;
        font-weight: 600;
      }
    }
  }

  .modal-footer {
    justify-content: space-evenly;
  }
}

.confirm-close.modal {
  z-index: 1031;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.6);

  .modal-dialog {
    max-width: initial;
    width: 40%;
    min-width: 22rem;
    max-width: 28rem;
  }

  .modal-header {
    font-weight: 600;
    padding-top: 1rem;
  }

  .modal-body {
    height: 4rem;
    padding: 1rem;
  }

  .modal-footer {
    justify-content: space-evenly;
  }
}
</style>
